
export const TOAST_CLASS_LIST = {
        "warning" : "top-notification",
        "report" :  "report_notification",
        "success" : "toast-success",
        "error" : "errorToast",
        "info":"info"

}

export const TOAST_ICON_LIST = {
        "warning" : "toastContact",
        "report" :  "toastMessage",
        "success" : "toastSuccess",
        "error" : "toastError",

}
export const TOAST_DELAY_TIME = 5000;
